var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-container',[_c('v-img',{staticClass:"image-404",attrs:{"contain":"","src":require("./../../public/404-image.jpg")}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }